export default __webpack_public_path__ + "static/media/tirpa.34efeba3.png";